export enum CustomQuestionType {
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  PARAGRAPH = 'PARAGRAPH',
  SUBTITLE = 'SUBTITLE',
  ATTACHMENT = 'ATTACHMENT',
}
